import React                            from 'react';
import { SET_SHOW_ORG_NAME_TEXT_FIELD } from 'actions';
import { store }                        from 'index';
import { approvedUserStateType }        from 'types';

const useGetOrgName = ( setApprovedUserState: (val: approvedUserStateType) => void ) => {
   
      React.useEffect(() => {

        const url_string       = window.location.href;
        const url              = new URL(url_string);
        const orgName          = url.searchParams.get("org_name");

        if (!orgName) {
          return
        }
      
        const arr                     = orgName.split(',').map((val: string) => { return +val })
        const decodedName             = String.fromCharCode.apply(null, arr)
        const setShowOrgNameTextField = (payload: boolean ) => store.dispatch(SET_SHOW_ORG_NAME_TEXT_FIELD(payload));

        console.log('decodedName : ',decodedName)

        setApprovedUserState({
          emailStr: '', 
          org_name: decodedName,
        })

        setShowOrgNameTextField(false)

      },[setApprovedUserState])

}


export default useGetOrgName;











